import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import updated_logo from "@/assets/footer-logo.png";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#F5F5DC] text-black text-center ">
      <div className="flex justify-center gap-6 md:gap-35 font-semibold mb-6 flex-wrap px-4 py-10">
        <Link to="/" className="text-black hover:opacity-75 transition-opacity">
          HOME
        </Link>
        <Link to="/about-us" className="text-black hover:opacity-75 transition-opacity">
          ABOUT US
        </Link>
        <Link to="/services" className="text-black hover:opacity-75 transition-opacity">
          SERVICES
        </Link>
        <Link to="/blogs" className="text-black hover:opacity-75 transition-opacity">
          BLOG
        </Link>
        <Link to="/testimonials" className="text-black hover:opacity-75 transition-opacity">
          TESTIMONIALS
        </Link>
        <Link to="/contact" className="text-black hover:opacity-75 transition-opacity">
          CONTACT US
        </Link>
      </div>
      <hr className="border-black border-opacity-20 mb-6 w-full" />
      {/*
      <p className="max-w-3xl mx-auto mb-6 text-xl leading-relaxed px-4 py-8">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt distinctio
        earum repellat quaerat voluptatibus placeat nam, commodi optio pariatur
        est quia magnam eum harum corrupti dicta, aliquam sequi voluptate quas.
      </p> */}

      <h3 className="my-16 flex justify-center">
        <img className="w-[15rem] md:w-[35rem]" src={updated_logo} alt="" />
      </h3>

      <div className="flex flex-col-reverse md:flex-row gap-5 md:gap-0 justify-between align-bottom p-10 pb-5">
        <p className="h-max text-sm">
          © OAKTREE - Design &amp; Developed by
          <a
            className="underline ml-1"
            href="https://cleverstudio.in"
            target="_blank"
          >
            Clever Studio.
          </a>
        </p>

        <div className="flex justify-center gap-8 text-2xl">
          <a
            href="https://www.facebook.com/share/14WAcRb3od/"
            target="_blank"
            className="hover:scale-110 transition-transform "
          >
            <FaFacebookF />
          </a>
          <a
            href="https://www.instagram.com/umakumaravelan/profilecard/?igsh=MTJtdzN1amdlZjlxbA=="
            target="_blank"
            className="hover:scale-110 transition-transform"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.linkedin.com/company/oak-tree-financial-planning/"
            target="_black"
            className="hover:scale-110 transition-transform"
          >
            <FaLinkedinIn />
          </a>
        </div>
      </div>
    </footer>
  );
}
